module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_Filter Widget

(function (fox, $) {
	'use strict';
	fox.registerWidget('Activity_Event_FilterNew', {

		configure: function () {
			this.viewSettings = {
				1: {visible: 1, name: 'liveshow', status: 1},
				2: {visible: 1, name: 'blogPost', status: 1},
				3: {visible: 0, name: 'message', status: 0},
				4: {visible: 0, name: 'trip', status: 0},
				5: {visible: 1, name: 'custom', status: 1},
				6: {visible: 1, name: 'photoset', status: 1},
				7: {visible: 1, name: 'video', status: 1}
			};

			/*this.viewSettings = {
				1: {visible: 1, name: 'liveshow', status: 0},
				2: {visible: 1, name: 'blogPost', status: 0},
				3: {visible: 0, name: 'message', status: 0},
				4: {visible: 0, name: 'trip', status: 1},
				5: {visible: 1, name: 'custom', status: 1},
				6: {visible: 1, name: 'photoset', status: 0},
				7: {visible: 1, name: 'video', status: 0}
			};*/



			this.filterTplOptions = {
				nextAvailable: true,
				prevAvailable: true,
				starDate: false,
				endDate: false
			};

			this.allEventsDates = [];

			this.registerOptions('', {
				autoRender: false,
				
				widgets: {
					filter1: {
						widget: 'Widget',
						template: 'activity_event_filter',
						autoRender: false
					},

					filter2: {
						widget: 'Widget',
						template: 'activity_event_filter',
						autoRender: false
					},

					settings: {
						widget: 'Widget',
						autoRender: true,
						template: 'activity_event_view_settings',
						embed: {
							widget: '@parent @parent @parent',
							container: '.activity-action.types'
						},
						widgets: {
							list: {
								widget: 'List',
								autoRender: true,
								container: '.setup-list',
								'tpl.row': 'activity_event_view_settings_row'
							}
						}
					},

					calendar: {
						widget: 'Widget',
						autoRender: false,
						dontReuseSn: true,
						template: 'activity_event_view_calendar',
						embed: {
							widget: '@parent @parent @parent',
							container: '.activity-action.calendar'
						},
						'hooks.onAddedToDom': fox.bind(this.applyDatePicker, this)
					},

					availableDatesApi: {
						widget: 'Api',
						method: 'Activity_Event.getCountsByDay',
						cacheChannel: 'event',
						sendTimezone: true
					}
				},
				handleDom: {
					nextEvents1: {
						target: '.arr.next',
						targetWidget: '#filter1',
						event: 'click',
						callback: 'getNextEvents'
					},

					prevEvents1: {
						target: '.arr.prev',
						targetWidget: '#filter1',
						event: 'click',
						callback: 'getPrevEvents'
					},

					nextEvents2: {
						target: '.arr.next',
						targetWidget: '#filter2',
						event: 'click',
						callback: 'getNextEvents'
					},

					prevEvents2: {
						target: '.arr.prev',
						targetWidget: '#filter2',
						event: 'click',
						callback: 'getPrevEvents'
					},

					toggleSettings: {
						event: 'click',
						targetWidget: '#settings',
						target: '.settings-button',
						callback: '_toggleDropdown'
					},

					toggleCalendar: {
						event: 'click',
						targetWidget: '#calendar',
						target: '.settings-button',
						callback: '_toggleDropdown'
					},

					toggleOption: {
						event: 'click',
						targetWidget: '#settings #list',
						target: '.view-settings-list-item',
						callback: 'toggleOption'
					},

					preventDropDownClose: {
						targetWidget: '#calendar',
						target: '.setup-list.calendar',
						event: 'click',
						callback: function (el, alias, w, e) {
							fox.dom.event.stop(e);
						}
					}
				},

				handleWom: {
					eventsApiSuccess: {
						widget: '@parent',
						event: ['eventsApiSuccess', 'getDataFromCache'],
						callback: '_handleEventsApiSuccess'
					},

					availableDates: {
						widget: '#availableDatesApi',
						event: 'success',
						callback: '_availableDatesApiLoad'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.direction = 'next';

			this.limit = this.getOption('limit');

			this.callParent('init', arguments);
		},

		running: function () {
			this.filterData = {
				date: fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', new Date()),
				direction: 'next',
				types: this.getViewSettings(),
				limit: this.limit
			};

			// temp
			this.rwom1('#settings #list').setCollection(this.viewSettings, true);
			this.dispatchData();
			this._addWindowClickEvents();
			this.getAvailableDates();
		
			this.callParent('running', arguments);
		},

		activate: function (argument) {
			this._addWindowClickEvents();
			this.dispatchData();
			this.getAvailableDates();
			this.callParent('activate', arguments);
		},

		deactivate: function (argument) {
			this._removeWindowClickEvents();
			this.callParent('deactivate', arguments);
		},

		_addWindowClickEvents: function (argument) {
			$(window).on('click', {widget: this}, this._closeAllDropdowns);
		},

		_removeWindowClickEvents: function (argument) {
			$(window).off('click', this._closeAllDropdowns);
		},

		_closeAllDropdowns: function (e) {
			e.data.widget.closeAllDropdowns();
		},

		closeAllDropdowns: function () {
			var paths = ['#settings', '#calendar'];

			fox.each(paths, function (path) {
				this._hideDropdown(this.wom1(path).dom1('.settings-button')); 
			}, this);
		},

		dispatchData: function () {
			// console.group('filterChanged')
			// 	console.table([this.filterData], ['date', 'direction'/*, 'limit'*/]);
			// console.groupEnd()
			
			this.dispatchEvent('filterChanged', this.filterData);

			return this.filterData;
		},

		_toggleDropdown: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			if ($(el).hasClass('opened')) {
				this._hideDropdown(el);

				return;
			}

			this._showDropdown(el);
		},

		_showDropdown: function (el) {
			this.closeAllDropdowns();
			$(el).addClass('opened');
		},

		_hideDropdown: function (el) {
			$(el).removeClass('opened');
		},

		toggleOption: function (el, alias, w, e) {
			fox.dom.event.stop(e);
			var $el;

			$el = $(el).find('[data-card-type]');

			if ($el.hasClass('on')) {
				$el.removeClass('on').addClass('off');
				this.viewSettings[$el.data('card-type')].status = 0;
			} else if ($el.hasClass('off')) {
				$el.removeClass('off').addClass('on');
				this.viewSettings[$el.data('card-type')].status = 1;
			}

			 this.filterData.types = this.getViewSettings();

			this.dispatchData();
		},

		getViewSettings: function () {
			var settings = {};

			fox.each(this.viewSettings, function (val, key) {
				settings[key] = val.status;
			});

			return settings;
		},

		getNextEvents: function () {
			//console.log('next');
			this.direction = this.filterData.direction = 'next';
			this.filterData.date = this.getPeriodFromCards().endDate;
			this.dispatchData();
		},

		getPrevEvents: function () {
			//console.log('prev');
			this.direction = this.filterData.direction = 'prev';
			this.filterData.date = this.getPeriodFromCards().startDate;
			this.dispatchData();
		},

		_handleEventsApiSuccess: function (result) {
			// console.group('_handleEventsApiSuccess')
			// 	console.table(result.collection, ['startDate', 'title', 'type', 'typedParams.id']);
			// console.groupEnd()

			if (!result.collection) {
				return;
			}

			if (result.collection.length) {
				this.setCurrentCards(result.collection);
				this.setCurrentDates(result.meta);
				this.setLimitation(result.meta);
				this.renderFilters();
			}
		},

		setCurrentCards: function (collection) {
			this.currentCards = collection;	
		},

		setCurrentDates: function (dates) {
			this.currentDates = dates;
		},

		setLimitation: function (meta) {
			this.filterTplOptions.nextAvailable = meta.hasNext;
			this.filterTplOptions.prevAvailable = meta.hasPrev;
		},

		getPeriodFromCards: function () {
			return {startDate: this.currentDates.minDate, endDate: this.currentDates.maxDate};
		},

		renderFilters: function () {
			var opts = fox.clone(this.filterTplOptions);
			var dates = this.getPeriodFromCards();

			fox.each(dates, function (date, key) {
				opts[key] = date;
			}, this);

			this.wom1('#filter1').setTemplateOptions(opts).render();
			this.wom1('#filter2').setTemplateOptions(opts).render();
		},

		applyDatePicker: function () {
			if (this.allEventsDates.length) {
				return;
			}

			$(this.wom1('#calendar').element[0])
				.find('.events-datepicker')
				.datepicker({
					dateFormat: "yy-mm-dd",//2015-01-30
					showWeek: false,
					nextText: '',
					prevText: '',
					appendText: 'a',
					beforeShowDay: fox.bind(function (cDate) {
						var clickable = false;
						var cName = '';
						var tooltip = '';
						cDate = fox.utils.dateFormat('%Y-%m-%d', cDate);

						fox.each(this.availableDates, function (data) {
							var eDate = fox.utils.dateFormat('%Y-%m-%d', data.date);

							if (cDate === eDate) {
								clickable = true;
								cName = 'clickable-date';
								tooltip = data.length + ' events on this date';
							}
						});

						return [clickable, cName, tooltip];
					}, this),

					onSelect: fox.bind(function (date) {
						this.closeAllDropdowns();
						var current = [date, '00:00:00'].join(' ');
						var nextDay = [date, '23:59:59'].join(' ');
						
						this.dispatchEvent('filterChanged', {
							durationFrom: current,
							durationTo: nextDay,
							types: this.getViewSettings()
						});
						
						this.currentDates.minDate = fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', current);
						this.currentDates.maxDate = fox.utils.dateFormat('%Y-%m-%d %H:%M:%S', nextDay);
					}, this)
				});
		},

		getAvailableDates: function (argument) {
			this.rwom1('#availableDatesApi').send();
		},

		_availableDatesApiLoad: function (response) {
			this.availableDates = response.answer.response;

			this.rwom1('#calendar').render();
		}

	}, 'Controller');

})(fox, window.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/filterNew.js
// module id = 818
// module chunks = 4